export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/shigonghetongzhiliangbaoxian-3f66c685f190095dbfb34ca1e84401a5.png";